import cn from 'classnames';
import { P } from 'components/base';
import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import React from 'react';
import Quote1 from 'svgs/elements/quote-1.svg';
import Quote2 from 'svgs/elements/quote-2.svg';
import Bookmark from 'svgs/icons/i-bookmark.svg';
import { content, from, hasPost, link, linkIcon, logoC, postC, quote1, quote2, root } from './TestimonialCard.module.scss';

const TestimonialCard = ({
  heading,
  position,
  name,
  logo,
  border,
  className,
  post,
}) => (
  <section
    className={cn(root, className, {
      [border]: border,
      [hasPost]: post,
    })}
  >
    <img src={logo.img.publicURL} alt={logo.alt} className={logoC} />
    <div className={content}>
      <Quote1 className={quote1} />
      <Quote2 className={quote2} />
      <P Tag="h3" size="L" marginBottom="Xs">
        {heading}
      </P>
      <div className={from}>
        —— &nbsp; {position} {name}
      </div>
    </div>
    {post ? (
      <div className={postC}>
        <Bookmark className={linkIcon} />
        <Link to={post.url} className={link}>
          {post.heading}
        </Link>
      </div>
    ) : null}
  </section>
);
TestimonialCard.propTypes = {
  heading: PropTypes.string,
  position: PropTypes.string,
  name: PropTypes.string,
  border: PropTypes.bool,
  className: PropTypes.string,
  logo: PropTypes.object,
  post: PropTypes.object,
};
TestimonialCard.defaultProps = {
  border: true,
};

export default TestimonialCard;
